export default __webpack_public_path__ + "static/media/tasks_completed.7e6847a7.svg";